import React from 'react';
import BazarCard from './BazarCard';
import FlexBox from './FlexBox';
import { Box, Container, MenuItem, styled } from '@mui/material';
import { categoryLandingRoutesById, routerUrls } from 'constants';
import { subCategoryDisplayName } from '../utils/categoryLabels';
import { GlobalContext } from '../context/GlobalState';
import { useEffect, useContext } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

// Category links read gold, bold and underlined at rest. The type takes gold.text -
// the only gold with enough contrast to read as type - while the rule under it takes
// gold.fill, which is a surface/border colour and must never be set on text.
const navLinkStyle = {
  cursor: 'pointer',
  marginRight: '2rem',
  textTransform: 'uppercase',
  fontSize: '15px',
  fontWeight: 700,
  letterSpacing: '0.06em',
  color: 'gold.text',
  paddingBottom: '4px',
  borderBottom: '1px solid',
  borderBottomColor: 'gold.fill',
  transition: 'color 150ms ease-in-out, border-color 150ms ease-in-out',
  '&:hover': {
    color: 'gold.deep',
    borderBottomColor: 'gold.deep'
  },
  '&:last-child': {
    marginRight: '0'
  }
};

//BazarCard
const NavBarWrapper = styled(Container)(({ theme }) => ({
  display: 'block',
  position: 'relative',
  borderBottom: `1px solid ${theme.palette.divider}`,
  width: '100%',
  [theme.breakpoints.down('sx')]: {
    display: 'none'
  }
}));
const InnerContainer = styled(Container)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  height: '100%'
}));

// GOTOBED NAVBAR COMPONENTS
export default function NavBar() {
  const { menu, setMenu } = useContext(GlobalContext);
  useEffect(async () => {
    if (!menu) {
      const { data } = await axios.get(`/menu`);
      setMenu(data);
    }
  }, []);

  const displayNavbar = () => {
    return menu?.map((category) => {
      return (
        <FlexBox
          position="relative"
          flexDirection="column"
          alignItems="center"
          key={category.id}
          sx={{
            '&:hover': {
              '& > .child-nav-item': {
                display: 'block'
              }
            }
          }}>
          {/* main category title name */}
          <Box
            component={Link}
            to={categoryLandingRoutesById[category.id] || routerUrls.root}
            sx={{ ...navLinkStyle, textDecoration: 'none' }}>
            {category.name_bg}
          </Box>
          <Box
            className="child-nav-item"
            sx={{
              display: 'none',
              position: 'absolute',
              left: 0,
              top: '100%',
              // above the sticky material filter bar (zIndex 100) so the menu overlays it,
              // still below MUI overlays (drawer 1200 / modal 1300)
              zIndex: 1000
            }}>
            <BazarCard
              sx={{
                mt: '1.25rem',
                py: '0.5rem',
                minWidth: '230px',
                backgroundColor: 'background.default',
                border: '1px solid',
                borderColor: 'divider',
                boxShadow: 'none'
              }}
              elevation={0}>
              {categoryLandingRoutesById[category.id] && (
                <Link
                  to={categoryLandingRoutesById[category.id]}
                  style={{ color: 'inherit', textDecoration: 'none' }}>
                  <MenuItem sx={{ fontWeight: 600 }}>Всички категории</MenuItem>
                </Link>
              )}
              {category.subCategories.map((subCategory) => {
                return (
                  <Link
                    to={
                      routerUrls.products +
                      '/' +
                      category.slug_bg +
                      '/' +
                      subCategory.slug_bg +
                      '/' +
                      category.id +
                      '/' +
                      subCategory.id
                    }
                    style={{ color: 'inherit', textDecoration: 'none' }}
                    key={subCategory.id}>
                    {/* sub category title name */}
                    <MenuItem>{subCategoryDisplayName(subCategory.name_bg)}</MenuItem>
                  </Link>
                );
              })}
            </BazarCard>
          </Box>
        </FlexBox>
      );
    });
  };

  return (
    <NavBarWrapper maxWidth={false} elevation={2} hoverEffect={false}>
      <InnerContainer
        sx={{
          justifyContent: 'center',
          pb: '10px'
        }}>
        <FlexBox>{displayNavbar()}</FlexBox>
      </InnerContainer>
    </NavBarWrapper>
  );
}
